import http from '@/config/api';
import router from '@/router';

export default {
  async getMonitoringList({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    await http.get(`event/${directory}/monitoring/list`).then((response) => {
      commit('SET_MONITORING_LIST', response?.data?.list);
    });
  },
  async getMonitoringStatus({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    await http.get(`event/${directory}/monitoring/status`).then((response) => {
      commit('SET_MONITORING_STATUS', response?.data?.status);
    });
  },
  async registMonitoringInfo({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    await http.post(`event/${directory}/monitoring`, payload).then(() => {
      commit('SET_MONITORING_INFO', payload);
    });
  },
  resetMonitoringInfo({ commit }) {
    commit('RESET_MONITORING_INFO');
  },
  async deleteMonitoring(_, payload) {
    const directory = router.currentRoute.value?.params.directory;
    await http.delete(`event/${directory}/monitoring/${payload.id}`).then((response) => response?.data);
  },
  async getMonitoredList({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    await http.get(`event/${directory}/monitored`).then((response) => {
      commit('SET_MONITORED_LIST', response?.data);
    });
  },
  async acceptMonitoredRequest(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    await http.post(`event/${directory}/monitored/${payload.id}`).then((response) => response?.data);
  },
  async rejectMonitoredRequest(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    await http.delete(`event/${directory}/monitored/${payload.id}`).then((response) => response?.data);
  },
  async getMonitoredNotice({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    await http.get(`event/${directory}/notices`).then((response) => {
      commit('SET_MONITORED_NOTICE', response?.data);
    });
  },
  async readMonitoredNotice(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    await http.delete(`event/${directory}/notice/${payload.id}`).then((response) => response?.data);
  },
};
